import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getNetSales } from '../services/user'

const initialState = {
  Staff_Engagement_Indexloading: false,
  Staff_Engagement_Index: [],

  Longetivity_Milestoneloading: false,
  Longetivity_Milestone: [],

  Total_Staffloading: false,
  Total_Staff: [],

  Retention_Rateloading: false,
  Retention_Rate: [],

  Staff_Absenteeismloading: false,
  Staff_Absenteeism: [],

  Staff_Absenteeism_Genderloading: false,
  Staff_Absenteeism_Gender: [],

  Student_Teacher_Ratioloading: false,
  Student_Teacher_Ratio: [],

  Schools_with_High_Absenteeismloading: false,
  Schools_with_High_Absenteeism: [],

  Schools_with_Least_Absenteeismloading: true,
  Schools_with_Least_Absenteeism: [],

  Top_Absence_Reasonloading: true,
  Top_Absence_Reason: [],

  Staff_Demographic_Snapshotloading: false,
  Staff_Demographic_Snapshot: [],

  Staff_Retention_Snapshotloading: false,
  Staff_Retention_Snapshot: [],

  Staff_Diversityloading: false,
  Staff_Diversity: [],

  Teacher_NonTeacher_Ratioloading: false,
  Teacher_NonTeacher_Ratio: [],

  White_NonWhiteloading: true,
  White_NonWhite: [],

  Schoolsloading: false,
  Schools: [],

  Table_viewloading: true,
  Table_view: [],

  Major_Absence_Reasonloading: false,
  Major_Absence_Reason: [],

  Schools_With_High_Absenteesloading: true,
  Schools_With_High_Absentees: [],

  Absenteesloading: false,
  Absentees: [],

  Dimension_viewloading: false,
  Dimension_view: [],

  Pop_Up_Absenteeismloading: false,
  Pop_Up_Absenteeism: [],

  Absentees_Trendloading: false,
  Absentees_Trend: [],

  Total_Staff_Genderloading: false,
  Total_Staff_Gender: [],

  Pop_Up_Trendloading: false,
  Pop_Up_Trend: [],

  Pop_Up_Reasonsloading: false,
  Pop_Up_Reasons: [],

  Attendance_table_popuploading: false,
  Attendance_table_popup: [],

  Top_tile_school_popuploading: false,
  Top_tile_school_popup: [],

  Top_Absence_table_popuploading: false,
  Top_Absence_table_popup: [],

  Top_tile_7day_school_popuploading: false,
  Top_tile_7day_school_popup: [],

  Staff_wise_popuploading: false,
  Staff_wise_popup: [],
}

export const fetchStaff_Engagement_Index = createAsyncThunk(
  'fetchStaff_Engagement_Index',
  async (Staff_Engagement_Index, thunkAPI) => {
    Staff_Engagement_Index = { ...Staff_Engagement_Index, elasticQueryName: "Staff Engagement Index" }
    const response = await getNetSales(Staff_Engagement_Index);
    return response.data
  }
)

export const fetchLongetivity_Milestone = createAsyncThunk(
  'fetchLongetivity_Milestone',
  async (Longetivity_Milestone, thunkAPI) => {
    Longetivity_Milestone = { ...Longetivity_Milestone, elasticQueryName: "Longetivity Milestone" }
    const response = await getNetSales(Longetivity_Milestone);
    return response.data
  }
)

export const fetchTotal_Staff = createAsyncThunk(
  'fetchTotal_Staff',
  async (Total_Staff, thunkAPI) => {
    Total_Staff = { ...Total_Staff, elasticQueryName: "Total Staff" }
    const response = await getNetSales(Total_Staff);
    return response.data
  }
)
  
export const fetchRetention_Rate = createAsyncThunk(
  'fetchRetention_Rate',
  async (Retention_Rate, thunkAPI) => {
    Retention_Rate = { ...Retention_Rate, elasticQueryName: "Retention Rate" }
    const response = await getNetSales(Retention_Rate);
    return response.data
  }
)

export const fetchStaff_Absenteeism = createAsyncThunk(
  'fetchStaff_Absenteeism',
  async (Staff_Absenteeism, thunkAPI) => {
    Staff_Absenteeism = { ...Staff_Absenteeism, elasticQueryName: "Staff Absenteeism" }
    const response = await getNetSales(Staff_Absenteeism);
    return response.data
  }
)

export const fetchStaff_Absenteeism_Gender = createAsyncThunk(
    'fetchStaff_Absenteeism_Gender',
    async (Staff_Absenteeism_Gender, thunkAPI) => {
      Staff_Absenteeism_Gender = { ...Staff_Absenteeism_Gender, elasticQueryName: "Staff_Absenteeism_Gender" }
      const response = await getNetSales(Staff_Absenteeism_Gender);
      return response.data
    }
  )

export const fetchStudent_Teacher_Ratio = createAsyncThunk(
    'fetchStudent_Teacher_Ratio',
    async (Student_Teacher_Ratio, thunkAPI) => {
      Student_Teacher_Ratio = { ...Student_Teacher_Ratio, elasticQueryName: "Student Teacher Ratio" }
      const response = await getNetSales(Student_Teacher_Ratio);
      return response.data
    }
  )

export const fetchSchools_with_High_Absenteeism = createAsyncThunk(
    'fetchSchools_with_High_Absenteeism',
    async (Schools_with_High_Absenteeism, thunkAPI) => {
        Schools_with_High_Absenteeism = { ...Schools_with_High_Absenteeism, elasticQueryName: "Schools with High Absenteeism" }
        const response = await getNetSales(Schools_with_High_Absenteeism);
        return response.data
    }
)


export const fetchSchools_with_Least_Absenteeism = createAsyncThunk(
    'fetchSchools_with_Least_Absenteeism',
    async (Schools_with_Least_Absenteeism, thunkAPI) => {
    Schools_with_Least_Absenteeism = { ...Schools_with_Least_Absenteeism, elasticQueryName: "Schools with Least Absenteeism" }
    const response = await getNetSales(Schools_with_Least_Absenteeism);
    return response.data
    }
)

export const fetchTop_Absence_Reason = createAsyncThunk(
    'fetchTop_Absence_Reason',
    async (Top_Absence_Reason, thunkAPI) => {
        Top_Absence_Reason = { ...Top_Absence_Reason, elasticQueryName: "Top Absence Reason" }
        const response = await getNetSales(Top_Absence_Reason);
        return response.data
    }
)

export const fetchStaff_Demographic_Snapshot = createAsyncThunk(
    'fetchStaff_Demographic_Snapshot',
    async (Staff_Demographic_Snapshot, thunkAPI) => {
      Staff_Demographic_Snapshot = { ...Staff_Demographic_Snapshot, elasticQueryName: "Staff Demographic Snapshot" }
      const response = await getNetSales(Staff_Demographic_Snapshot);
      return response.data
    }
  )

  export const fetchStaff_Retention_Snapshot = createAsyncThunk(
    'fetchStaff_Retention_Snapshot',
    async (Staff_Retention_Snapshot, thunkAPI) => {
      Staff_Retention_Snapshot = { ...Staff_Retention_Snapshot, elasticQueryName: "Staff Retention Snapshot" }
      const response = await getNetSales(Staff_Retention_Snapshot);
      return response.data
    }
  )

  export const fetchStaff_Diversity = createAsyncThunk(
    'fetchStaff_Diversity',
    async (Staff_Diversity, thunkAPI) => {
      Staff_Diversity = { ...Staff_Diversity, elasticQueryName: "Staff Diversity" }
      const response = await getNetSales(Staff_Diversity);
      return response.data
    }
  )

  export const fetchTeacher_NonTeacher_Ratio = createAsyncThunk(
    'fetchTeacher_NonTeacher_Ratio',
    async (Teacher_NonTeacher_Ratio, thunkAPI) => {
      Teacher_NonTeacher_Ratio = { ...Teacher_NonTeacher_Ratio, elasticQueryName: "Teacher /Non-Teacher Ratio" }
      const response = await getNetSales(Teacher_NonTeacher_Ratio);
      return response.data
    }
  )
  
  
  export const fetchWhite_NonWhite = createAsyncThunk(
    'fetchWhite_NonWhite',
    async (White_NonWhite, thunkAPI) => {
      White_NonWhite = { ...White_NonWhite, elasticQueryName: "White/Non-White" }
      const response = await getNetSales(White_NonWhite);
      return response.data
    }
  )

  export const fetchSchools = createAsyncThunk(
    'fetchSchools',
    async (Schools, thunkAPI) => {
      Schools = { ...Schools, elasticQueryName: "Schools" }
      const response = await getNetSales(Schools);
      return response.data
    }
  )
  
  
  export const fetchTable_view = createAsyncThunk(
    'fetchTable_view',
    async (Table_view, thunkAPI) => {
      Table_view = { ...Table_view, elasticQueryName: "Table_view" }
      const response = await getNetSales(Table_view);
      return response.data
    }
  )

  export const fetchMajor_Absence_Reason = createAsyncThunk(
    'fetchMajor_Absence_Reason',
    async (Major_Absence_Reason, thunkAPI) => {
      Major_Absence_Reason = { ...Major_Absence_Reason, elasticQueryName: "Major Absence Reason" }
      const response = await getNetSales(Major_Absence_Reason);
      return response.data
    }
  )
  
  export const fetchSchools_With_High_Absentees = createAsyncThunk(
    'fetchSchools_With_High_Absentees',
    async (Schools_With_High_Absentees, thunkAPI) => {
      Schools_With_High_Absentees = { ...Schools_With_High_Absentees, elasticQueryName: "Schools With High Absentees" }
      const response = await getNetSales(Schools_With_High_Absentees);
      return response.data
    }
  )

  export const fetchAbsentees = createAsyncThunk(
    'fetchAbsentees',
    async (Absentees, thunkAPI) => {
      Absentees = { ...Absentees, elasticQueryName: "Absentees" }
      const response = await getNetSales(Absentees);
      return response.data
    }
  )

  export const fetchDimension_view = createAsyncThunk(
    'fetchDimension_view',
    async (Dimension_view, thunkAPI) => {
      Dimension_view = { ...Dimension_view, elasticQueryName: "Dimension_view" }
      const response = await getNetSales(Dimension_view);
      return response.data
    }
  )

  export const fetchPop_Up_Absenteeism = createAsyncThunk(
    'fetchPop_Up_Absenteeism',
    async (Pop_Up_Absenteeism, thunkAPI) => {
      Pop_Up_Absenteeism = { ...Pop_Up_Absenteeism, elasticQueryName: "Pop_Up_Absenteeism" }
      const response = await getNetSales(Pop_Up_Absenteeism);
      return response.data
    }
  )

  export const fetchAbsentees_Trend = createAsyncThunk(
    'fetchAbsentees_Trend',
    async (Absentees_Trend, thunkAPI) => {
      Absentees_Trend = { ...Absentees_Trend, elasticQueryName: "Absentees_Trend" }
      const response = await getNetSales(Absentees_Trend);
      return response.data
    }
  )

  export const fetchTotal_Staff_Gender = createAsyncThunk(
    'fetchTotal_Staff_Gender',
    async (Total_Staff_Gender, thunkAPI) => {
      Total_Staff_Gender = { ...Total_Staff_Gender, elasticQueryName: "Total_Staff_Gender" }
      const response = await getNetSales(Total_Staff_Gender);
      return response.data
    }
  )

  export const fetchPop_Up_Trend = createAsyncThunk(
    'fetchPop_Up_Trend',
    async (Pop_Up_Trend, thunkAPI) => {
      Pop_Up_Trend = { ...Pop_Up_Trend, elasticQueryName: "Pop_Up_Trend" }
      const response = await getNetSales(Pop_Up_Trend);
      return response.data
    }
  )
  
  export const fetchPop_Up_Reasons = createAsyncThunk(
    'fetchPop_Up_Reasons',
    async (Pop_Up_Reasons, thunkAPI) => {
      Pop_Up_Reasons = { ...Pop_Up_Reasons, elasticQueryName: "Pop_Up_Reasons" }
      const response = await getNetSales(Pop_Up_Reasons);
      return response.data
    }
  )

  export const fetchAttendance_table_popup = createAsyncThunk(
    'fetchAttendance_table_popup',
    async (Attendance_table_popup, thunkAPI) => {
      Attendance_table_popup = { ...Attendance_table_popup, elasticQueryName: "Attendance_table_popup" }
      const response = await getNetSales(Attendance_table_popup);
      return response.data
    }
  )

export const fetchTop_tile_school_popup = createAsyncThunk(
  'fetchTop_tile_school_popup',
  async (Top_tile_school_popup, thunkAPI) => {
    Top_tile_school_popup = { ...Top_tile_school_popup, elasticQueryName: "Top_tile_school_popup" }
    const response = await getNetSales(Top_tile_school_popup);
    return response.data
  }
)

export const fetchTop_Absence_table_popup = createAsyncThunk(
  'fetchTop_Absence_table_popup',
  async (Top_Absence_table_popup, thunkAPI) => {
    Top_Absence_table_popup = { ...Top_Absence_table_popup, elasticQueryName: "Top_ Absence_table_popup" }
    const response = await getNetSales(Top_Absence_table_popup);
    return response.data
  }
)

export const fetchTop_tile_7day_school_popup = createAsyncThunk(
  'fetchTop_tile_7day_school_popup',
  async (Top_tile_7day_school_popup, thunkAPI) => {
    Top_tile_7day_school_popup = { ...Top_tile_7day_school_popup, elasticQueryName: "Top_tile_7day_school_popup" }
    const response = await getNetSales(Top_tile_7day_school_popup);
    return response.data
  }
)

export const fetchStaff_wise_popup = createAsyncThunk(
  'fetchStaff_wise_popup',
  async (Staff_wise_popup, thunkAPI) => {
    Staff_wise_popup = { ...Staff_wise_popup, elasticQueryName: "Staff_wise_popup" }
    const response = await getNetSales(Staff_wise_popup);
    return response.data
  }
)

export const staffdetails = createSlice({
  name: 'staffdetails',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(fetchStaff_Engagement_Index.fulfilled, (state, action) => {
      state.Staff_Engagement_Index = action.payload;
      state.Staff_Engagement_Indexloading = false;
    }).addCase(fetchStaff_Engagement_Index.pending, (state, action) => {
      state.Staff_Engagement_Indexloading = true;
    })

    builder.addCase(fetchLongetivity_Milestone.fulfilled, (state, action) => {
      state.Longetivity_Milestone = action.payload;
      state.Longetivity_Milestoneloading = false;
    }).addCase(fetchLongetivity_Milestone.pending, (state, action) => {
      state.Longetivity_Milestoneloading = true;
    })

    builder.addCase(fetchTotal_Staff.fulfilled, (state, action) => {
      state.Total_Staff = action.payload;
      state.Total_Staffloading = false;
    }).addCase(fetchTotal_Staff.pending, (state, action) => {
      state.Total_Staffloading = true;
    })


    builder.addCase(fetchRetention_Rate.fulfilled, (state, action) => {
      state.Retention_Rate = action.payload;
      state.Retention_Rateloading = false;
    }).addCase(fetchRetention_Rate.pending, (state, action) => {
      state.Retention_Rateloading = true;
    })

    builder.addCase(fetchStaff_Absenteeism.fulfilled, (state, action) => {
      state.Staff_Absenteeism = action.payload;
      state.Staff_Absenteeismloading = false;
    }).addCase(fetchStaff_Absenteeism.pending, (state, action) => {
      state.Staff_Absenteeismloading = true;
    })

    builder.addCase(fetchStaff_Absenteeism_Gender.fulfilled, (state, action) => {
      state.Staff_Absenteeism_Gender = action.payload;
      state.Staff_Absenteeism_Genderloading = false;
    }).addCase(fetchStaff_Absenteeism_Gender.pending, (state, action) => {
      state.Staff_Absenteeism_Genderloading = true;
    })

    builder.addCase(fetchStudent_Teacher_Ratio.fulfilled, (state, action) => {
        state.Student_Teacher_Ratio = action.payload;
        state.Student_Teacher_Ratioloading = false;
    }).addCase(fetchStudent_Teacher_Ratio.pending, (state, action) => {
        state.Student_Teacher_Ratioloading = true;
    })

    builder.addCase(fetchSchools_with_High_Absenteeism.fulfilled, (state, action) => {
        state.Schools_with_High_Absenteeism = (action.payload).reverse();
        state.Schools_with_High_Absenteeismloading = false;
    }).addCase(fetchSchools_with_High_Absenteeism.pending, (state, action) => {
        state.Schools_with_High_Absenteeismloading = true;
    })  

    builder.addCase(fetchSchools_with_Least_Absenteeism.fulfilled, (state, action) => {
        state.Schools_with_Least_Absenteeism = (action.payload).reverse();
        state.Schools_with_Least_Absenteeismloading = false;
    }).addCase(fetchSchools_with_Least_Absenteeism.pending, (state, action) => {
        state.Schools_with_Least_Absenteeismloading = true;
    })  

    builder.addCase(fetchTop_Absence_Reason.fulfilled, (state, action) => {
        state.Top_Absence_Reason = (action.payload).reverse();
        state.Top_Absence_Reasonloading = false;
    }).addCase(fetchTop_Absence_Reason.pending, (state, action) => {
        state.Top_Absence_Reasonloading = true;
    })

    builder.addCase(fetchStaff_Demographic_Snapshot.fulfilled, (state, action) => {
        state.Staff_Demographic_Snapshot = action.payload;
        state.Staff_Demographic_Snapshotloading = false;
    }).addCase(fetchStaff_Demographic_Snapshot.pending, (state, action) => {
        state.Staff_Demographic_Snapshotloading = true;
    })

    builder.addCase(fetchStaff_Retention_Snapshot.fulfilled, (state, action) => {
      state.Staff_Retention_Snapshot = action.payload;
      state.Staff_Retention_Snapshotloading = false;
    }).addCase(fetchStaff_Retention_Snapshot.pending, (state, action) => {
      state.Staff_Retention_Snapshotloading = true;
    }) 

    builder.addCase(fetchStaff_Diversity.fulfilled, (state, action) => {
      state.Staff_Diversity = action.payload;
      state.Staff_Diversityloading = false;
    }).addCase(fetchStaff_Diversity.pending, (state, action) => {
      state.Staff_Diversityloading = true;
    })

    builder.addCase(fetchTeacher_NonTeacher_Ratio.fulfilled, (state, action) => {
      state.Teacher_NonTeacher_Ratio = action.payload;
      state.Teacher_NonTeacher_Ratioloading = false;
    }).addCase(fetchTeacher_NonTeacher_Ratio.pending, (state, action) => {
      state.Teacher_NonTeacher_Ratioloading = true;
    })  

    builder.addCase(fetchWhite_NonWhite.fulfilled, (state, action) => {
      state.White_NonWhite = action.payload;
      state.White_NonWhiteloading = false;
    }).addCase(fetchWhite_NonWhite.pending, (state, action) => {
      state.White_NonWhiteloading = true;
    }) 

    builder.addCase(fetchSchools.fulfilled, (state, action) => {
      state.Schools = action.payload;
      state.Schoolsloading = false;
    }).addCase(fetchSchools.pending, (state, action) => {
      state.Schoolsloading = true;
    })  

    builder.addCase(fetchTable_view.fulfilled, (state, action) => {
      state.Table_view = (action.payload);
      state.Table_viewloading = false;
    }).addCase(fetchTable_view.pending, (state, action) => {
      state.Table_viewloading = true;
    })  

    builder.addCase(fetchMajor_Absence_Reason.fulfilled, (state, action) => {
      state.Major_Absence_Reason = action.payload;
      state.Major_Absence_Reasonloading = false;
    }).addCase(fetchMajor_Absence_Reason.pending, (state, action) => {
      state.Major_Absence_Reasonloading = true;
    })  

    builder.addCase(fetchSchools_With_High_Absentees.fulfilled, (state, action) => {
      state.Schools_With_High_Absentees = action.payload;
      state.Schools_With_High_Absenteesloading = false;
    }).addCase(fetchSchools_With_High_Absentees.pending, (state, action) => {
      state.Schools_With_High_Absenteesloading = true;
    })  

    builder.addCase(fetchAbsentees.fulfilled, (state, action) => {
      state.Absentees = action.payload;
      state.Absenteesloading = false;
    }).addCase(fetchAbsentees.pending, (state, action) => {
      state.Absenteesloading = true;
    })

    builder.addCase(fetchDimension_view.fulfilled, (state, action) => {
      state.Dimension_view = action.payload;
      state.Dimension_viewloading = false;
    }).addCase(fetchDimension_view.pending, (state, action) => {
      state.Dimension_viewloading = true;
    })

    builder.addCase(fetchPop_Up_Absenteeism.fulfilled, (state, action) => {
      state.Pop_Up_Absenteeism = (action.payload);
      state.Pop_Up_Absenteeismloading = false;
    }).addCase(fetchPop_Up_Absenteeism.pending, (state, action) => {
      state.Pop_Up_Absenteeismloading = true;
    })

    builder.addCase(fetchAbsentees_Trend.fulfilled, (state, action) => {
      state.Absentees_Trend = action.payload;
      state.Absentees_Trendloading = false;
    }).addCase(fetchAbsentees_Trend.pending, (state, action) => {
      state.Absentees_Trendloading = true;
    })

    builder.addCase(fetchTotal_Staff_Gender.fulfilled, (state, action) => {
      state.Total_Staff_Gender = action.payload;
      state.Total_Staff_Genderloading = false;
    }).addCase(fetchTotal_Staff_Gender.pending, (state, action) => {
      state.Total_Staff_Genderloading = true;
    })

    builder.addCase(fetchPop_Up_Trend.fulfilled, (state, action) => {
      state.Pop_Up_Trend = action.payload;
      state.Pop_Up_Trendloading = false;
    }).addCase(fetchPop_Up_Trend.pending, (state, action) => {
      state.Pop_Up_Trendloading = true;
    })

    builder.addCase(fetchPop_Up_Reasons.fulfilled, (state, action) => {
      state.Pop_Up_Reasons = action.payload;
      state.Pop_Up_Reasonsloading = false;
    }).addCase(fetchPop_Up_Reasons.pending, (state, action) => {
      state.Pop_Up_Reasonsloading = true;
    })

    builder.addCase(fetchAttendance_table_popup.fulfilled, (state, action) => {
      state.Attendance_table_popup = action.payload;
      state.Attendance_table_popuploading = false;
    }).addCase(fetchAttendance_table_popup.pending, (state, action) => {
      state.Attendance_table_popuploading = true;
    })

    builder.addCase(fetchTop_tile_school_popup.fulfilled, (state, action) => {
      state.Top_tile_school_popup = action.payload;
      state.Top_tile_school_popuploading = false;
    }).addCase(fetchTop_tile_school_popup.pending, (state, action) => {
      state.Top_tile_school_popuploading = true;
    })

    builder.addCase(fetchTop_Absence_table_popup.fulfilled, (state, action) => {
      state.Top_Absence_table_popuploading = false;
      state.Top_Absence_table_popup = action.payload;
    }).addCase(fetchTop_Absence_table_popup.pending, (state, action) => {
      state.Top_Absence_table_popuploading = true;
    })

    builder.addCase(fetchTop_tile_7day_school_popup.fulfilled, (state, action) => {
      state.Top_tile_7day_school_popup = action.payload;
      state.Top_tile_7day_school_popuploading = false;
    }).addCase(fetchTop_tile_7day_school_popup.pending, (state, action) => {
      state.Top_tile_7day_school_popuploading = true;
    })

    builder.addCase(fetchStaff_wise_popup.fulfilled, (state, action) => {
      state.Staff_wise_popup = action.payload;
      state.Staff_wise_popuploading = false;
    }).addCase(fetchStaff_wise_popup.pending, (state, action) => {
      state.Staff_wise_popuploading = true;
    })
  }

})

// Action creators are generated for each case reducer function
// export const { increment, decrement, incrementByAmount } = counterSlice.actions

export default staffdetails.reducer